import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Analytics } from '@vercel/analytics/react'
import LandingPage from './components/LandingPage'
import LoginPage from './components/LoginPage'
import ProblemList from './components/ProblemList'
import SolveProblemPage from './components/SolveProblemPage'
import ProtectedRoute from './components/ProtectedRoute'
import OAuthCallbackPage from './components/OAuthCallbackPage'
import './index.css'

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route 
            path="/login" 
            element={
              <ProtectedRoute requireAuth={false}>
                <LoginPage />
              </ProtectedRoute>
            } 
          />
          <Route path="/auth/callback" element={<OAuthCallbackPage />} />
          {/* Protected routes */}
          <Route 
            path="/problems" 
            element={
              <ProtectedRoute>
                <ProblemList />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/solve/:problemId" 
            element={
              <ProtectedRoute>
                <SolveProblemPage />
              </ProtectedRoute>
            } 
          />
          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Analytics />
      </div>
    </Router>
  )
}

export default App 